export interface VideoItem {
  id: number;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  categoryName: string;
  duration: string;
  views: number;
  rating: number;
  isFeatured: boolean;
  isPremium: boolean;
  date: string;
  author: string;
  tags: string[];
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "人工智能时代：如何构建你的核心竞争力",
    description: "深入探讨AI时代个人能力提升的关键路径，从技术理解到实践应用，帮助你在变革中把握机遇。本课程涵盖机器学习基础、数据分析思维、以及AI工具的实际运用场景。",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20futuristic%20workspace%20with%20holographic%20AI%20displays%20and%20a%20person%20interacting%20with%20digital%20interfaces%2C%20warm%20amber%20lighting%2C%20clean%20minimal%20composition%2C%20professional%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20soft%20shadows&width=640&height=360&seq=video-thumb-001&orientation=landscape",
    category: "zhichang",
    categoryName: "职场技能",
    duration: "45:30",
    views: 128600,
    rating: 4.9,
    isFeatured: true,
    isPremium: true,
    date: "2026-08-01",
    author: "李明远",
    tags: ["人工智能", "职业发展", "技能提升"],
  },
  {
    id: 2,
    title: "探索敦煌莫高窟：千年壁画的秘密",
    description: "跟随镜头走进神秘的敦煌莫高窟，近距离欣赏千年壁画的精美细节，了解壁画背后的历史文化故事和艺术价值。专家带你解读那些鲜为人知的壁画密码。",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Dunhuang%20Mogao%20Caves%20interior%20with%20colorful%20Buddhist%20murals%20and%20sculptures%2C%20warm%20golden%20light%20illuminating%20the%20ancient%20art%2C%20mysterious%20atmosphere%2C%20soft%20texture%2C%20cultural%20heritage%20photography&width=640&height=360&seq=video-thumb-002&orientation=landscape",
    category: "jiaoyu",
    categoryName: "教育学习",
    duration: "58:20",
    views: 95300,
    rating: 4.8,
    isFeatured: true,
    isPremium: false,
    date: "2026-07-28",
    author: "张文化",
    tags: ["敦煌", "历史文化", "艺术鉴赏"],
  },
  {
    id: 3,
    title: "2026年最值得期待的10部国产大片",
    description: "盘点2026年下半年即将上映的国产大片，从科幻巨制到文艺佳作，为你提前揭晓最受期待的影片看点、幕后制作故事和主创访谈。",
    thumbnail: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20dramatic%20lighting%20and%20Chinese%20film%20elements%2C%20warm%20theater%20ambiance%2C%20golden%20and%20crimson%20tones%2C%20professional%20film%20photography%20style%2C%20rich%20contrast&width=640&height=360&seq=video-thumb-003&orientation=landscape",
    category: "yule",
    categoryName: "娱乐影视",
    duration: "22:15",
    views: 215000,
    rating: 4.7,
    isFeatured: true,
    isPremium: false,
    date: "2026-08-05",
    author: "王电影",
    tags: ["电影推荐", "国产电影", "2026新片"],
  },
  {
    id: 4,
    title: "30分钟全身燃脂训练：居家高效健身计划",
    description: "专业教练为你设计的高效燃脂方案，无需器械、不挑场地，30分钟让你大汗淋漓。包含热身、核心训练、有氧运动和拉伸放松四个环节，适合所有健身水平。",
    thumbnail: "https://readdy.ai/api/search-image?query=Bright%20modern%20home%20gym%20setting%20with%20yoga%20mat%20and%20fitness%20equipment%2C%20warm%20natural%20sunlight%20streaming%20through%20windows%2C%20clean%20minimal%20aesthetic%2C%20energetic%20atmosphere%2C%20soft%20warm%20tones&width=640&height=360&seq=video-thumb-004&orientation=landscape",
    category: "tiyu",
    categoryName: "体育运动",
    duration: "32:40",
    views: 167800,
    rating: 4.8,
    isFeatured: false,
    isPremium: true,
    date: "2026-08-03",
    author: "陈健体",
    tags: ["健身", "燃脂", "居家运动"],
  },
  {
    id: 5,
    title: "日本茶道艺术：一期一会的禅意美学",
    description: '走进京都传统茶室，体验日本茶道的完整流程。从茶具准备、点茶手法到品茶礼仪，感受「和敬清寂」的茶道精神，领悟东方美学的深邃内涵。',
    thumbnail: "https://readdy.ai/api/search-image?query=Traditional%20Japanese%20tea%20ceremony%20in%20a%20serene%20tatami%20room%2C%20warm%20soft%20lighting%2C%20ceramic%20tea%20bowl%20and%20bamboo%20whisk%2C%20zen%20atmosphere%2C%20minimal%20composition%2C%20peaceful%20and%20elegant%20mood&width=640&height=360&seq=video-thumb-005&orientation=landscape",
    category: "shenghuo",
    categoryName: "生活方式",
    duration: "41:10",
    views: 78200,
    rating: 4.9,
    isFeatured: false,
    isPremium: false,
    date: "2026-07-25",
    author: "林雅致",
    tags: ["茶道", "日本文化", "生活美学"],
  },
  {
    id: 6,
    title: "Python数据分析从入门到精通：实战项目篇",
    description: "通过五个真实商业案例，手把手教你使用Python进行数据分析。涵盖Pandas数据处理、Matplotlib可视化、以及Scikit-learn机器学习建模的完整流程。",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20developer%20workspace%20with%20multiple%20screens%20displaying%20Python%20code%20and%20data%20visualization%20charts%2C%20warm%20desk%20lamp%20lighting%2C%20clean%20organized%20desk%2C%20professional%20coding%20environment%2C%20cozy%20tech%20atmosphere&width=640&height=360&seq=video-thumb-006&orientation=landscape",
    category: "keji",
    categoryName: "科技数码",
    duration: "1:25:00",
    views: 189200,
    rating: 4.8,
    isFeatured: true,
    isPremium: true,
    date: "2026-08-02",
    author: "刘程师",
    tags: ["Python", "数据分析", "编程教程"],
  },
  {
    id: 7,
    title: "古典吉他演奏：阿尔罕布拉宫的回忆",
    description: "青年吉他演奏家倾情演绎塔雷加经典名曲《阿尔罕布拉宫的回忆》，精湛的轮指技巧配合西班牙风情的旋律，带你感受古典吉他的独特魅力。",
    thumbnail: "https://readdy.ai/api/search-image?query=Classical%20guitar%20close-up%20with%20musician%20hands%20on%20strings%2C%20warm%20stage%20spotlight%2C%20elegant%20concert%20atmosphere%2C%20dark%20background%20with%20soft%20golden%20rim%20light%2C%20intimate%20performance%20photography&width=640&height=360&seq=video-thumb-007&orientation=landscape",
    category: "yinyue",
    categoryName: "音乐艺术",
    duration: "18:55",
    views: 45600,
    rating: 4.9,
    isFeatured: false,
    isPremium: false,
    date: "2026-07-30",
    author: "周弦音",
    tags: ["古典吉他", "音乐演奏", "西洋古典"],
  },
  {
    id: 8,
    title: "从零开始做UP主：内容创作全攻略",
    description: "资深内容创作者分享从选题策划、拍摄制作到平台运营的完整经验。了解如何找准定位、吸引粉丝、持续产出优质内容，让你的创作之路少走弯路。",
    thumbnail: "https://readdy.ai/api/search-image?query=Content%20creator%20studio%20setup%20with%20camera%20ring%20light%20and%20microphone%2C%20warm%20cozy%20video%20production%20environment%2C%20creative%20workspace%2C%20soft%20ambient%20lighting%2C%20professional%20youtuber%20setup%2C%20modern%20interior&width=640&height=360&seq=video-thumb-008&orientation=landscape",
    category: "yuanchuang",
    categoryName: "原创精品",
    duration: "36:20",
    views: 134500,
    rating: 4.7,
    isFeatured: true,
    isPremium: true,
    date: "2026-08-06",
    author: "赵创作",
    tags: ["自媒体", "内容创作", "UP主教程"],
  },
  {
    id: 9,
    title: "探秘云南普洱：古茶山的千年茶韵",
    description: "深入云南普洱茶核心产区，探访千年古茶树，了解从采摘到制作的全过程。茶农讲述世代传承的制茶技艺，品味最纯正的普洱茶香。",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20tea%20mountains%20in%20Yunnan%20with%20terraced%20tea%20plantations%20under%20morning%20mist%2C%20warm%20golden%20sunlight%2C%20traditional%20tea%20farmers%20harvesting%2C%20lush%20green%20landscape%2C%20peaceful%20rural%20atmosphere&width=640&height=360&seq=video-thumb-009&orientation=landscape",
    category: "shenghuo",
    categoryName: "生活方式",
    duration: "52:30",
    views: 67200,
    rating: 4.8,
    isFeatured: false,
    isPremium: false,
    date: "2026-07-20",
    author: "林雅致",
    tags: ["普洱茶", "茶文化", "云南旅行"],
  },
  {
    id: 10,
    title: "Excel高效办公秘籍：20个必学技巧",
    description: "告别重复劳动，掌握20个职场Excel高级技巧。从数据透视表到VLOOKUP函数，从条件格式到宏录制，让你的办公效率翻倍提升。",
    thumbnail: "https://readdy.ai/api/search-image?query=Clean%20modern%20office%20desk%20with%20laptop%20displaying%20Excel%20spreadsheet%20and%20charts%2C%20warm%20natural%20light%2C%20minimal%20workspace%2C%20professional%20environment%2C%20organized%20desk%20with%20coffee%20cup%2C%20soft%20shadows&width=640&height=360&seq=video-thumb-010&orientation=landscape",
    category: "zhichang",
    categoryName: "职场技能",
    duration: "38:15",
    views: 256300,
    rating: 4.8,
    isFeatured: false,
    isPremium: false,
    date: "2026-08-04",
    author: "李明远",
    tags: ["Excel", "办公技巧", "效率提升"],
  },
  {
    id: 11,
    title: "星空摄影入门：捕捉银河的绝美瞬间",
    description: "专业星空摄影师教你如何选择设备、设置参数、寻找最佳拍摄地点。从基础星空摄影知识到后期处理技巧，让你也能拍出震撼的银河大片。",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20night%20sky%20with%20milky%20way%20galaxy%20over%20mountain%20landscape%2C%20camera%20on%20tripod%20in%20foreground%2C%20deep%20blue%20and%20purple%20cosmic%20colors%2C%20silhouette%20of%20photographer%2C%20breathtaking%20astrophotography%20scene&width=640&height=360&seq=video-thumb-011&orientation=landscape",
    category: "jiaoyu",
    categoryName: "教育学习",
    duration: "48:00",
    views: 89700,
    rating: 4.9,
    isFeatured: false,
    isPremium: true,
    date: "2026-07-22",
    author: "张文化",
    tags: ["摄影教程", "星空摄影", "户外"],
  },
  {
    id: 12,
    title: "国潮崛起：新中式穿搭指南2026",
    description: "解析2026年新中式穿搭趋势，从汉服元素到现代设计，教你如何将传统美学融入日常穿搭。多位时尚博主分享搭配心得和品牌推荐。",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20fashion%20style%20with%20traditional%20elements%2C%20elegant%20clothing%20on%20mannequin%20in%20warm%20studio%20lighting%2C%20minimal%20fashion%20photography%2C%20soft%20beige%20and%20warm%20tones%2C%20contemporary%20oriental%20aesthetic&width=640&height=360&seq=video-thumb-012&orientation=landscape",
    category: "shenghuo",
    categoryName: "生活方式",
    duration: "28:45",
    views: 145200,
    rating: 4.6,
    isFeatured: false,
    isPremium: false,
    date: "2026-08-07",
    author: "陈时尚",
    tags: ["穿搭", "新中式", "时尚潮流"],
  },
];

export const featuredCollections = [
  {
    id: 1,
    title: "AI时代必修课",
    description: "掌握人工智能核心技能，抢占未来职场先机",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20glowing%20neural%20network%20visuals%2C%20warm%20amber%20and%20gold%20accents%2C%20clean%20modern%20design%2C%20abstract%20digital%20art%2C%20professional%20tech%20aesthetic&width=480&height=270&seq=collection-001&orientation=landscape",
    videoCount: 12,
  },
  {
    id: 2,
    title: "文化之旅",
    description: "走遍世界文化遗产，感受人类文明的博大精深",
    coverImage: "https://readdy.ai/api/search-image?query=World%20cultural%20heritage%20sites%20collage%20with%20ancient%20temples%20and%20monuments%2C%20warm%20golden%20hour%20lighting%2C%20rich%20cultural%20atmosphere%2C%20travel%20photography%20style%2C%20soft%20earthy%20tones&width=480&height=270&seq=collection-002&orientation=landscape",
    videoCount: 8,
  },
  {
    id: 3,
    title: "健康生活家",
    description: "科学健身、营养饮食、心理健康，全方位守护你的健康",
    coverImage: "https://readdy.ai/api/search-image?query=Healthy%20lifestyle%20concept%20with%20fresh%20ingredients%20and%20fitness%20elements%2C%20warm%20natural%20light%2C%20clean%20modern%20kitchen%20setting%2C%20green%20plants%2C%20wellness%20atmosphere%2C%20soft%20and%20inviting%20composition&width=480&height=270&seq=collection-003&orientation=landscape",
    videoCount: 10,
  },
  {
    id: 4,
    title: "编程进阶之路",
    description: "从入门到精通，系统学习最热门的编程语言和框架",
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20code%20on%20dark%20editor%20screen%20with%20colorful%20syntax%20highlighting%2C%20modern%20developer%20setup%2C%20warm%20ambient%20lighting%2C%20minimal%20tech%20aesthetic%2C%20professional%20coding%20environment&width=480&height=270&seq=collection-004&orientation=landscape",
    videoCount: 15,
  },
];

export const platformStats = [
  { label: "精品视频", value: "50,000+", icon: "ri-video-line" },
  { label: "优质创作者", value: "3,200+", icon: "ri-user-star-line" },
  { label: "日均访客", value: "120万+", icon: "ri-eye-line" },
  { label: "内容分类", value: "8大类", icon: "ri-stack-line" },
];